<template>
  <div class="home-box">
    <top-head></top-head>
    <video-part ref="videoPartRef"></video-part>
    <div class="game-box">
      <title-bar title="贝塔游戏"></title-bar>
      <div class="game-swiper">
        <div class="slider-box">
          <slick ref="slick" :options="slickOptions" @afterChange="slide">
            <img src="../../../static/images/home/game11.jpg">
            <img src="../../../static/images/home/game1.jpg">
            <img src="../../../static/images/home/game2.jpg">
            <img src="../../../static/images/home/game3.jpg">
            <img src="../../../static/images/home/game4.jpg">
            <img src="../../../static/images/home/game5.jpg">
            <img src="../../../static/images/home/game6.jpg">
            <img src="../../../static/images/home/game7.jpg">
            <img src="../../../static/images/home/game8.jpg">
            <img src="../../../static/images/home/game9.jpg">
            <img src="../../../static/images/home/game10.jpg">
          </slick>
        </div>
        <div class="game-scroll">
          <div class="game-scroll-item" @click="scrollItemClick(item)"
            :class="item==activeScroll?'game-scroll-active':''" v-for="item in 11" :key="item"></div>
        </div>
        <div class="game-font">
          <div class="game-font-title">{{gameTitle}}</div>
          <div class="game-font-content">
            {{gameFont}}
          </div>
        </div>
      </div>
    </div>
    <div class="join-us">
      <img src="../../../static/images/home/joinus.jpg" />
      <div class="join-us-content">
        <div class="join-us-title">
          加入我们
        </div>
        <div class="join-us-card">
          <a href="http://fotoable.hirede.com/CareerSite/Index" target="_blank">
            <div class="join-us-card-left" @mouseover="szmouseOver" @mouseleave="szmouseLeave">
              <div class="join-us-card-title" v-show="szShow">社会招聘</div>
              <div class="join-us-card-title2" v-show="!szShow">
                <div class="join-us-card-title2-1">社会招聘</div>
                <div class="join-us-card-font">
                  Social Recruitment
                </div>
              </div>
            </div>
          </a>
          <a href="http://fotoable.hirede.com/CareerSite/CampusRecruit" target="_blank">
            <div class="join-us-card-right" @mouseover="xzmouseOver" @mouseleave="xzmouseLeave">
              <div class="join-us-card-title" v-show="xzShow">校园招聘</div>
              <div class="join-us-card-title2" v-show="!xzShow">
                <div class="join-us-card-title2-1">校园招聘</div>
                <div class="join-us-card-font">
                  Campus Recruitment
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
    <home-foot></home-foot>
  </div>
</template>
<script>
  import topHead from '../parts/headPart';
  import videoPart from '../parts/home/videoPart.vue';
  import homeFoot from '../parts/homeFoot.vue'
  import Slick from 'vue-slick';
  import TitleBar from '../common/title-bar.vue';
  import 'slick-carousel/slick/slick.css';
  export default {
    name: 'homePage',
    components: {
      topHead,
      videoPart,
      homeFoot,
      Slick,
      TitleBar
    },
    data() {
      return {
        slickOptions: {
          centerMode: true, //中心模式
          autoplay: true, //自动播放
          arrows: false, //不显示箭头
          draggable: false, //不可拖动
          focusOnSelect: true, //单击幻灯片
          variableWidth: true, //允许不同宽度幻灯片
          slidesToShow: 5
        },
        gameTitle: '',
        gameFont: '',
        szShow: true,
        xzShow: true,
        activeScroll: 1,
        gameWord: [{
          title: '融融童话岛',
          content: '这是一个等待你探索和重建的美妙仙境。在这里，你拥有魔法，可以随心所欲地组合物品，收获丰富多样的元素和娃娃伙伴，驱散迷雾，解锁和构建属于自己的岛屿。'
        },{
          title: 'Meeerge',
          content: '一个迷之漂流瓶中隐藏的危险力量夺走了部落的重要神器！在追寻它的旅途中，您需要借助老祭司代代相传的合成法术不断探索新的土地、维持部落的正常运转。为了拯救你的部落，马上率领你的部落成员展开冒险吧！'
        }, {
          title: 'Buddies',
          content: '文字兄弟是一款免费并且非常有趣的字谜游戏，可以锻炼你的大脑并扩充你的词汇量。每个面板都有独特的组成元素，带给你新奇特别的游戏体验！有个人模式和组队模式供你选择。你还可以和团队成员聊天或者分享生活趣事～'
        }, {
          title: 'Crossy',
          content: 'Word Crossy是一款轻松的拼词类游戏，只需在游戏面板上将字母连接成词。12000多关卡、上万的词汇从易到难让你在娱乐中学习，帮助你成为拼写大师。每日挑战和超级周赛带给你更大的挑战，也为你准备了绝佳的奖励！'
        }, {
          title: 'Crush',
          content: '在寻找新的填字游戏吗？想要一款沉浸式游戏来锻炼大脑吗？来玩文字消除并开始你的文字之旅吧！玩法简单！只需滑动并连接字母即可找到字谜中的单词。享受经典的单词拼图，当您的猜测正确时，字母块会逐渐消失！'
        }, {
          title: 'Dragon Farm Adventure',
          content: '勇敢的冒险家们，欢迎来到Dragon Farm Adventure，开启寻龙之旅。你的好朋友辛西娅继承了一个神秘的岛屿，意外发现这里隐藏着不为人知的神龙一族。在这里你可以陪她一起建造龙乐园，培育神龙，也可以带着神龙一起去不同的场景冒险探索。'
        }, {
          title: 'Solitaire Home Design',
          content: 'Solitaire Home Design，免费且极具挑战性的纸牌谜题游戏终于上线啦！ 艾迪和洛瑞是这款游戏的主角，在游戏中他们会讲述精彩的故事，改造并翻新整个岛屿，与此同时，你也能玩到各类有趣的解谜小游戏，来锻炼你的大脑吧！'
        }, {
          title: 'Mergical',
          content: '欢迎来到奇幻小岛Mergical！这是一片充满了魔法和幻想气息的神秘领地。在这里，你可以探索未知的世界，并建造一座属于自己的岛屿！一款完美的合成建造游戏。'
        }, {
          title: 'Tank Hero',
          content: '坦克大战已经打响，敌人已整装待发。而你需要做的是，使用你特殊的能力来抵御敌人坦克的入侵，并伺机发动反击。要记得，一旦你的坦克阵亡，一切便从零开始。'
        }, {
          title: 'Townest',
          content: "欢迎来到Townest：Alfred's Adventure！ 获取线索， 帮助Alfred寻找他失踪的祖母。 究竟谁才是这一切谜团的幕后黑手？ 这是一个神秘的魔法小镇。 探索小镇来发现更多的秘密！ 完成关卡来帮助小镇恢复昔日繁华！ "
        }, {
          title: 'Word Villas',
          content: '破解字谜，收集奖励，一起打造属于自己的温馨住宅。这里有跌宕起伏的剧情故事，母女的分歧，前男友的纠缠，闺蜜的纷争……主角的烦恼等着你来解决！这里有数百件漂亮家具，少女心，公主梦，温馨家具……等着你来解锁！'
        }]
      }
    },
    mounted() {
      this.gameTitle = this.gameWord[0].title
      this.gameFont = this.gameWord[0].content
      window.addEventListener('scroll', this.getScroll);
    },
    destroyed() {
      window.removeEventListener('scroll', this.getScroll);
    },
    methods: {
      //监听滚动
      getScroll() {
        let indexNumTop = document.getElementsByClassName('game-box')[0].getBoundingClientRect().top
        if (indexNumTop < 0) {
          this.$refs.videoPartRef.videoSuspend()
        }
      },
      scrollItemClick(i) {
        this.$refs.slick.goTo(i - 1);
      },
      slide(event, slick, currentSlide) {
        this.activeScroll = currentSlide + 1
        this.gameTitle = this.gameWord[currentSlide].title
        this.gameFont = this.gameWord[currentSlide].content
      },
      szmouseOver() {
        this.szShow = false
      },
      szmouseLeave() {
        this.szShow = true
      },
      xzmouseOver() {
        this.xzShow = false
      },
      xzmouseLeave() {
        this.xzShow = true
      }
    }
  }
</script>

<style lang="less">
  img {
    -webkit-user-drag: none;
  }

  .home-box {

    .game-swiper {
      height: 519px;
      background-color: #000C36;
      padding-top: 55px;

      .slider-box {
        height: 280px;

        img {
          vertical-align: middle;
        }

        .slick-slide {
          width: 360px;
          margin: 78px 10px 0 10px;
        }

        .slick-active {
          img {
            transform: translate(-70px, 0);
          }
        }

        .slick-center {
          transform: scale(1.39);
          margin-top: 39px;

          img {
            transform: translate(0);
          }
        }

        .slick-center+.slick-active {
          transform: translate(140px, 0);
        }

        .slick-center+.slick-active+.slick-active {
          transform: translate(140px, 0);
        }
      }

      .game-scroll {
        width: 550px;
        height: 4px;
        margin: 0 auto;
        margin-top: 30px;
        position: relative;

        .game-scroll-item {
          width: 50px;
          height: 4px;
          background-color: rgba(255, 255, 255, 0.4);
          display: inline-block;
          cursor: pointer;

          &:hover {
            background-color: #fff;
          }
        }

        .game-scroll-active {
          background-color: #fff;
        }
      }

      .game-font {
        color: #fff;

        .game-font-title {
          margin-top: 35px;
          height: 28px;
          line-height: 28px;
          font-size: 24px;
        }

        .game-font-content {
          width: 500px;
          margin: 0 auto;
          margin-top: 22px;
          font-size: 14px;
          line-height: 22px;
          text-align: left;
        }
      }
    }

    .join-us {
      width: 100%;
      position: relative;

      img {
        width: 100%;
        vertical-align: middle;
      }

      .join-us-content {
        display: flex;
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        align-items: center;
        justify-content: center;
        flex-direction: column;
      }

      .join-us-title {
        font-size: 36px;
        line-height: 36px;
        color: #fff;
      }

      .join-us-card {
        margin-top: 40px;

        a>div {
          width: 525px;
          height: 380px;
          display: inline-block;
          margin: 0 15px;
          position: relative;
          cursor: pointer;
          background-size: cover;
        }

        .join-us-card-left {
          background-image: url(../../../static/images/home/sz.jpg);
        }

        .join-us-card-right {
          background-image: url(../../../static/images/home/xz.jpg);
        }

        .join-us-card-title {
          width: 100%;
          font-size: 36px;
          color: #fff;
          line-height: 72px;
          background-color: rgba(0, 0, 0, 0.4);
          position: absolute;
          bottom: 0;
        }

        .join-us-card-title2 {
          position: absolute;
          width: 100%;
          height: 230px;
          color: #fff;
          background-color: rgba(0, 0, 0, 0.4);
          padding-top: 150px;

          .join-us-card-title2-1 {
            font-size: 36px;
            line-height: 36px;
          }

          .join-us-card-font {
            font-size: 24px;
            line-height: 24px;
            margin-top: 15px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/index.vue